/**
 * Ordena uma lista de faturas pelo valor de boletoVeins.
 * @param {PanoramaInvoice[]} invoices - A lista de faturas.
 * @param {string} property - O mês que deve ser usado para ordenar. Valores possíveis: 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'.
 * @param {boolean} ascending - Se true, ordena de forma ascendente, se false, de forma descendente.
 * @returns {PanoramaInvoice[]} - A lista ordenada de faturas.
 */

export function sortPanoramaInvoiceByBoletoVeins(
  invoices,
  property,
  ascending = true,
) {
  return invoices.sort((a, b) => {
    const aValue = a[property] ? a[property].boletoVeins : 0;
    const bValue = b[property] ? b[property].boletoVeins : 0;

    if (ascending) {
      return aValue - bValue;
    } else {
      return bValue - aValue;
    }
  });
}
